<template>
    <div>
        <div class="form-group text-right">
            <button class="btn-sm btn-primary" data-toggle="modal" :data-target="'#modal-new'">Izveidot jaunu sarakstu</button>
        </div>
        <div class="modal fade" tabindex="-1"  :id="'modal-new'" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna saraksta pievienošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modalMenu">

                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="title">Nosaukums</label>
                                    <input type="text" name="title" id="title" v-model="title" class="form-control" :class="{'is-invalid':errors && ( 'title' in errors)}" autocomplete="off">
                                    <small class="text-danger" v-if="errors && errors.title">{{errors.title[0]}}</small>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group text-right">
                                    <input type="button" v-if="loading == false" class="btn btn-primary" value="Izveidot" @click="create()">
                                    <button type="button" v-else class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    mounted()
    {

    },
    data()
    {
        return{
            loading:false,
            title:"",
            errors:[],
        }
    },
    methods:{

        create()
        {
            var that = this;
            that.loading = true;
            axios.post('/researcher/create',{
                title: this.title
            }).then(response =>{
                if(response.data.status == 'ok')
                {
                    that.loading = false;
                    that.$toast.open(response.data.message);
                    $('#modal-new').modal('hide');
                    window.location.replace("/researcher/show/"+response.data.list.id);
                }
                else {
                    that.errors = response.data.errors;
                    that.$toast.error(response.data.message);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
</style>
